import { useState, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import { useRoomDayTime } from "./hooks/useRoomDateTime";

import * as React from "react";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function AddNewRoomDayTime() {
  const { updateRoomDayTime, roomDayTime } = useRoomDayTime();
  const orientation = roomDayTime?.onBreak ? "left" : "right";
  const [alignment, setAlignment] = React.useState<string | null>(orientation);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [room, setRoom] = useState<string>("");
  const [day, setDay] = useState<string>("");
  const [time, setTime] = useState<string>("");

  const [onBreak, setOnBreak] = useState(false);

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    setAlignment(newAlignment);
    if (roomDayTime && newAlignment == "right") {
      setOnBreak(false);
      setRoom(roomDayTime?.room);
      setDay(roomDayTime?.day);
      setTime(roomDayTime?.time);
    } else {
      setOnBreak(true);
      setDay("");
      setTime("");
      setRoom("");
    }
  };

  useEffect(() => {
    if (roomDayTime) {
      setRoom(roomDayTime?.room);
      setDay(roomDayTime?.day);
      setTime(roomDayTime?.time);
      setOnBreak(roomDayTime.onBreak);
      setAlignment(roomDayTime.onBreak ? "left" : "right");
    }
  }, [roomDayTime]);
  const handleRDTUpdate = async () => {
    try {
      if (!onBreak && (!room || !day || !time)) {
        setSuccessMessage("❌ Please fill in all fields.");
        return;
      }

      await updateRoomDayTime({ room, day, time, onBreak });

      setSuccessMessage(
        `✅ Room/Day/Time/onBreak updated successfully! to ${
          room || "[none]"
        } ${day || "[none]"} ${time || "[none]"} ${
          onBreak ? "ON BREAK" : "IN SCHOOL"
        }`
      );

      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      setSuccessMessage("❌ Failed to update. Please try again.");
    }
  };

  return (
    <>
      <div className="faq">
        <div style={{ textAlign: "center" }}>
          <h1>UPDATE ROOM / DAY / TIME / ON BREAK</h1>
          <div style={{ padding: 10 }}>
            <TextField
              value={room}
              onChange={(e) => setRoom(e.target.value)}
              size="small"
              label="New Room"
              inputProps={{ style: { textTransform: "uppercase" } }}
              required
            ></TextField>
            <TextField
              value={day}
              onChange={(e) => setDay(e.target.value)}
              size="small"
              label="New Day"
              inputProps={{ style: { textTransform: "uppercase" } }}
              required
            ></TextField>
            <TextField
              value={time}
              onChange={(e) => setTime(e.target.value)}
              size="small"
              label="New Time"
              inputProps={{ style: { textTransform: "uppercase" } }}
              required
            ></TextField>
            <ToggleButtonGroup
              value={alignment}
              exclusive
              onChange={handleAlignment}
              aria-label="text alignment"
              style={{ marginTop: 10 }}
            >
              <ToggleButton
                value="left"
                aria-label="left aligned"
                color="warning"
              >
                <h5>On Break</h5>
              </ToggleButton>
              <ToggleButton
                value="right"
                aria-label="right aligned"
                color="success"
              >
                <h5>In School</h5>
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <Button
            onClick={handleRDTUpdate}
            variant="contained"
            sx={{ marginTop: 3 }}
          >
            UPDATE ROOM / DAY / TIME / ONBREAK
          </Button>
          {successMessage && (
            <p
              style={{
                marginTop: 20,
                marginBottom: -10,
                color: successMessage.startsWith("❌") ? "red" : "green",
              }}
            >
              {successMessage}
            </p>
          )}
        </div>
      </div>
    </>
  );
}
